module.exports = function() {
  return new Worker(__webpack_public_path__ + "js/socket.worker.shim-ddd7858930b63247885f.js");
};